import { install, uninstall } from "@github/hotkey";

import { application } from "./stimulus_app";

/** In which Birdcar decides to punt Google across the room, for which they earned it
 *
 * We want to allow folks to drag and drop files onto the UI so we can use them, right? Right.
 * Here's the thing. In a _sensible_ browser -- ya know, one that understands that they're
 * supposed to be a frame that respects all documented browser events and doesn't hijack them
 * -- this is fairly straightforward. There's a `drop` event that happens when you release the
 * mouse, you make an event listener to react to it.
 *
 * However, Google, in its infinite, insanely selfish wisdom, decided that no, Chrome will
 * just catch that event and open the file you dropped in a new tab. That's clearly what you
 * meant and what every developer will expect. /s
 *
 * Also, to fix this we can't just call `preventDefault()` on the element we want to catch
 * that event, that would make too much sense. You *have* to prevent default on the document
 * first or your element will never receive the event in the first place.
 *
 * Leading to this: We're just gonna _force_ Chrome, when in a Yetto window, to fucking
 * behave itself.
 */
document.addEventListener("drop", (event) => {
  event.preventDefault();
});

// Turns out this one is necessary too because they're *also* fucking with that one.
document.addEventListener("dragover", (event) => {
  event.preventDefault();
});

let scrollTop = 0;

interface DetailsToggleEvent {
  event: Event;
  value: boolean;
}
// Custom "open" event action for details elements
application.registerActionOption(
  "open",
  ({ event, value }: DetailsToggleEvent) => {
    if (event.type === "toggle") {
      const detailsTarget = event.target as HTMLDetailsElement;
      return detailsTarget.open === value;
    } else {
      return true;
    }
  },
);

addEventListener("turbo:click", (event) => {
  if (event.target instanceof HTMLElement) {
    const target = event.target;
    if (target.hasAttribute("data-turbo-preserve-scroll")) {
      if (document.scrollingElement !== undefined) {
        scrollTop = document.documentElement.scrollTop;
      } else {
        scrollTop = 0;
      }
    }
  }
});

// Install all key commands that you can find
addEventListener("turbo:load", () => {
  document.scrollingElement?.scrollTo(0, scrollTop);
  scrollTop = 0;
  for (const el of document.querySelectorAll("[data-hotkey]")) {
    install(el as HTMLElement);
  }
});

// Uninstall old key commands to avoid old references
addEventListener("turbo:before-frame-render", () => {
  for (const el of document.querySelectorAll("[data-hotkey]")) {
    uninstall(el as HTMLElement);
  }
});
